import styled from 'styled-components';

export default styled.div`
  justify-content: space-around;
  flex: 1;

  .custom-chart-cont {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .legend {
    display: flex;
    flex-wrap: no-wrap;
    gap: 10px;
    margin-top: 40px;

    .default-data {
      flex: 1;
      transition: .2s opacity;

      .value-cont {
        display: flex;
        width: 80px;
        margin-left: auto;
        margin-right: auto;
        
        .main {
          flex: 1;
          display: flex;
          justify-content: flex-end;

          .square {
            width: 12px;
            height: 12px;
            margin-top: 14px;
            border-radius: 2px;
            margin-right: 8px;
          }
        }

        .value {
          flex: 1;
          text-align: left;
        }
      }
    }
  }

  .default-data {
    .value-cont {
      .value {
        font-size: 30px;
        margin-bottom: 0px;
      }
    }
  }
`;

export const ChartStyle = styled.div`
  width: 80%;
  left: 10%;
  position: relative;

  svg {
    width: 100%;
    transform: rotate(-90deg);
    background: #EDEDED;
    border-radius: 100%;
    clip-path: circle(50%);
    transition: .2s opacity;
  }

  .main-svg {
    position: relative;
  }

  .first-cont {
    position: absolute;
    width: 85%;
    height: 85%;
    padding: 8%;
    background: white;
    border-radius: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.custom {
      width: 82%;
      height: 82%;
    }

    .placeholder-cont {
      position: absolute;
      width: 85%;
      height: 85%;
      top: 7.5%;
      right: 7.5%;
      background: transparent;
      z-index: 2;
    }
  }

  .second-cont {
    position: absolute;
    width: 56%;
    height: 56%;
    padding: 10%;
    background: white;
    border-radius: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
